import { Component, DestroyRef, Input, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot } from '@angular/router';

import { DeviceService, UserService } from '@frontend/vanilla/core';
import { distinctUntilChanged, skip } from 'rxjs';

import { DetailedEventViewModel } from '../event-details-common/event-details-common.models';
import { EventDetailsModalService } from './event-details-modal.service';
import { EventDetailsResolver } from './event-details.resolver';

@Component({
    selector: 'ms-event-details-modal',
    templateUrl: './event-details-modal.component.html',
    standalone: false,
})
export class EventDetailsModalComponent {
    @Input() detailedEventModel: DetailedEventViewModel;
    @Input() route: ActivatedRouteSnapshot;

    private destroyRef = inject(DestroyRef);

    constructor(
        private eventDetailsModalService: EventDetailsModalService,
        private eventDetailsResolver: EventDetailsResolver,
        private deviceService: DeviceService,
        public userService: UserService,
    ) {
        this.deviceService.orientation.pipe(distinctUntilChanged(), skip(1), takeUntilDestroyed(this.destroyRef)).subscribe(() => this.updateData());
    }

    close(): void {
        this.eventDetailsModalService.close();
    }

    private async updateData(): Promise<void> {
        this.detailedEventModel = await this.eventDetailsResolver.modalResolve(this.route);
    }
}
